import axios from "axios";
import TEMPLATES from "@/constants/templates";
import TEMPLATE_SERVICES from "@/services/templates";
import { cloneDeep } from "lodash";

const TYPE = {
    PURCHASE_ORDER: 10,
    ATTACHMENT: 9,
    BUNDLE: 1,
    BUNDLE_ESTIMATE: 11,
    CONTENT_SNIPPET: 4,
    CUSTOM_FIELD: 8,
    LETTER: 6,
    MEDICAL_NOTE: 5,
    WELLNESS_PLAN: 7,
    WEBFORM: 12 // WIP:this constant already in helper.js
};

function defaultState() {
    return {
        templateType: null,
        templateId: null,
        isEditMode: false,
        isSavingEdit: false,
        details: {
            title: null,
            description: null,
            supplier: null,
            shipTo: null,
            billTo: null,
            total: null,
            sourceCatalog: null
        },
        editDetails: {},
        webformContent: {},
        items: [],
        modalItem: null
    };
}

const state = defaultState();

const getters = {};

const mutations = {
    setDetails(state, payload) {
        state.details = payload;
    },
    setWebformContent(state, payload) {
        state.webformContent = payload;
    },
    setEditDetails(state, payload) {
        state.editDetails = payload;
    },
    toggleEdit(state, value) {
        state.isEditMode = value;
    },
    copyDetailsToEdit(state) {
        state.editDetails = cloneDeep(state.details); // clone instead of refer
    },
    commitEditDetails(state) {
        state.details = { ...state.editDetails };
        state.isEditMode = false;
    },
    toggleSavingEdit(state, value) {
        state.isSavingEdit = value;
    },
    setTemplateId(state, value) {
        state.templateId = value;
    },
    setTemplateType(state, value) {
        state.templateType = value;
    },
    resetState(state) {
        Object.assign(state, defaultState());
    },
    setItems(state, payload) {
        state.items = payload;
    },
    setModalItem(state, modalItem) {
        state.modalItem = modalItem;
    }
};

const actions = {
    reset({ commit }) {
        commit("resetState");
    },
    startEdit({ commit }) {
        // copy details into another 'temporary' edit details
        // so that if user cancel the edit operation, we can revert to the original values
        commit("copyDetailsToEdit");

        // toggle edit
        commit("toggleEdit", true);
    },
    async saveEdit({ commit, state }, { removeAllItems }) {
        commit("toggleSavingEdit", true);

        let { isEditMode, templateId, editDetails } = state;
        let { title, description, supplier, sourceCatalog } = editDetails;

        let res = {};

        try {
            // use FormData instead of JSON for CI. Currently Purchase Order is still using CI endpoint.
            let fd = new FormData();
            fd.append("id", isEditMode ? templateId : null);
            fd.append("type", 10);
            fd.append("name", title);
            fd.append("description", description);
            fd.append("source_catalog", sourceCatalog || null);
            fd.append("supplier_id", supplier ? supplier.value : null);

            res = await axios.post(
                `${process.env.CI_APPS}business/template/save`,
                fd
            );

            // remove all items (if applicable)
            if (removeAllItems && state.templateType === TYPE.PURCHASE_ORDER) {
                let arr = [];

                for (let item of state.items) {
                    let uri = `${process.env.BARRAMUNDI}account/purchase-order-element/${item.id}`;
                    arr.push(axios.delete(uri));
                }

                await Promise.all(arr);
                state.items = [];
            }

            commit("commitEditDetails");
            commit("toggleSavingEdit", false);

            return res;
        } catch (error) {
            console.log(error);
        }
    },
    openModalItem({ state }, { isEdit, item }) {
        if (state.modalItem && typeof state.modalItem.open === "function") {
            state.modalItem.open(isEdit, item);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
